"use client";
import Clock from "react-live-clock";

export interface TimezoneProps {
  timeZone?: string;
  label?: string;
}

export function Timezone({
  timeZone = "Australia/Melbourne",
  label = "Melbourne:",
}: TimezoneProps) {
  return (
    <div className="flex flex-row">
      <p className="mr-1 text-xsm font-semibold">{label}</p>
      <Clock
        format={"ddd hh:mm A"}
        ticking={true}
        timezone={timeZone}
        className="text-xsm"
        noSsr
      />
    </div>
  );
}
